const URLbuilder = (url, ...queryParams) => {
  const queryArray = queryParams.filter((q) => q); // remove empty strings
  const queryParamString = queryArray.join("&");
  const qM = queryParamString.length ? "?" : "";
  return `${url}${qM}${queryParamString}`;
};

export default URLbuilder;
